function formatNumber(number) {
    return Number(number).toFixed(1);
}

export { formatNumber };